import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/attribute';
const endpoint_valuelist = '/valuelist';

export default {
  get(params: any) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  getItem(id: number, params: any) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  put(id: number, data: object) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + id,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  post(data: object) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  getValuelist(params: any) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint_valuelist,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  postValuelist(data: object) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint_valuelist,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
